import { getContext } from '@fiverr-private/fiverr_context';

export const isTargetPage = () => {
    const { pathParameters } = getContext();
    const paramKeys = Object.keys(pathParameters || {});

    // Seller page: /:username (exactly 1 param named 'username')
    const isSellerPage = paramKeys.length === 1 && paramKeys.includes('username');

    // Gig page: /:username/:slug (exactly 2 params named 'username' and 'slug')
    const isGigPage = paramKeys.length === 2 && paramKeys.includes('username') && paramKeys.includes('slug');

    return isSellerPage || isGigPage;
};
